import * as tslib_1 from "tslib";
import React from 'react';
var Toggle = /** @class */ (function (_super) {
    tslib_1.__extends(Toggle, _super);
    function Toggle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Toggle.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, title = _a.title, isOpen = _a.isOpen, componentClass = _a.componentClass, componentType = _a.componentType, _b = _a.componentProps, componentProps = _b === void 0 ? {} : _b, props = tslib_1.__rest(_a, ["children", "className", "title", "isOpen", "componentClass", "componentType", "componentProps"]);
        // This is necessary to ensure the compiler that the componentClass will not be empty even though it's optional
        var Component = componentClass || Toggle.defaultProps.componentClass;
        return (React.createElement(Component, tslib_1.__assign({ className: className, title: title, role: "button", "aria-haspopup": true, "aria-expanded": isOpen }, props, componentProps), children));
    };
    Toggle.defaultProps = {
        componentType: Toggle,
        componentClass: 'div',
    };
    return Toggle;
}(React.Component));
export default Toggle;
//# sourceMappingURL=Toggle.js.map